export function getdata() {
    let obj = {
        conditionOpTypes: [
            { label: '固定值', value: '05' },
            { label: '固定精度', value: '04' },
            { label: '百分比', value: '03' }
        ],
        rangeOpTypes: [
            { label: 'round', value: '1' },
            { label: 'round up', value: '2' },
            { label: 'round down', value: '3' }
        ]
    };
    return obj
}
